import { toast } from "react-toastify";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";
import { ProjectStateType } from "../EditProjectContext";
import { getSpdrById } from "./getSpdrById";
import { getSpdrOnRouteById } from "./getSpdrOnRouteById";
import { updateSpdrFTLIdentifier } from "../LeftSide/UpdateSpdrFTLIdentifier";
import { setSpdrsOnThisRoute } from "./setSpdrsOnThisRoute";
import getRoutingInfo from "../../GetRoutingInfo";
import { CardType } from "../LeftSide/CardType";
import { insertDragNDropCardToRoute } from "./insertDragNDropCardToRoute";
import { getOdcs } from "./getOdcs";
import { RelationType } from "../../../TransportNetwork/RelationType";
import { RoutingType } from "../../ViewModel/RoutingType";
import { RouteType } from "../../ViewModel/RouteType";

export async function handleSpdr(
  draggableId: string,
  route: FtlRouteViewModel,
  routeId: number,
  projectState: ProjectStateType,
  spdrId: number
) {
  const { project, setProject } = projectState;
  if (route.RouteType === "ST-Return" || route.RouteType === "Trunk") {
    toast(`SPDR cannot added on Route with Type ${route.RouteType}`, {
      type: "error",
    });
    return;
  }

  const draggedSpdr = getSpdrById(spdrId, project);
  if (!draggedSpdr) {
    toast(`Error while try to add SPDR`, {
      type: "error",
    });
    return;
  }

  const { Supplier, Plant } = await getRoutingInfo(
    project.ProjectId || -1,
    draggedSpdr.SupplierGsdb,
    draggedSpdr.PlantGsdb,
    draggedSpdr.DockCode,
    RelationType.Spdr,
    CardType.spdr
  );

  const spdrOnRoute = getSpdrOnRouteById(route, spdrId);
  if (spdrOnRoute) {
    toast(`Error while try to add SPDR`, {
      type: "error",
    });
    return;
  }

  if (draggedSpdr.ShipFrequency === 0) {
    draggedSpdr.ShipFrequency = 11;
  }

  const odcs = getOdcs(route.RoutingTable);

  if (
    Supplier.RoutingType === RoutingType.ODC &&
    (route.RouteType === RouteType.FTL2 || route.RouteType === RouteType["Top-Up"])
  ) {
    odcs.push({ OdcGsdb: Supplier.Gsdb });
  }

  if (
    Plant.RoutingType === RoutingType.ODC &&
    (route.RouteType === RouteType.FTL2 || route.RouteType === RouteType["Top-Up"])
  ) {
    odcs.push({ OdcGsdb: Plant.Gsdb });
  }

  const newSpdr = {
    ...draggedSpdr,
    ODCs: odcs,
  };

  route.SpdrsOnThisRoute?.push(newSpdr);
  if (draggedSpdr.UsedInFtlRoutes) {
    draggedSpdr.UsedInFtlRoutes += 1;
  }
  setProject(updateSpdrFTLIdentifier(project));
  setSpdrsOnThisRoute(projectState, routeId, route.SpdrsOnThisRoute);

  insertDragNDropCardToRoute(draggedSpdr, route, Supplier, Plant, projectState);
}
